import { initReactI18next } from 'react-i18next'
import i18n from 'i18next'
// Dev (保留)
import accountDev from './dev/account.json'
import alertDev from './dev/alert.json'
import commonDev from './dev/common.json'
import commonDistanceDev from './dev/commonDistance.json'
import crTargetDev from './dev/crTarget.json'
import deviceDev from './dev/device.json'
import formItemsDev from './dev/formItems.json'
import globalEmSourceDev from './dev/globalEmSource.json'
import goodsDev from './dev/goods.json'
import importSettingDev from './dev/importSetting.json'
import menuDev from './dev/menu.json'
import powerinputDev from './dev/powerinput.json'
import regionCoeffiDev from './dev/regionCoeffi.json'
import globalCarbonReductionDev from './dev/report-globalCarbonReduction.json'
import globalEmDev from './dev/report-globalEm.json'
import reportDev from './dev/report.json'
import systemDev from './dev/system.json'
import tableColumnsDev from './dev/tableColumns.json'
// ZhTW
import accountZhTW from './zh_TW/account.json'
import alertZhTW from './zh_TW/alert.json'
import assessmentZhTW from './zh_TW/assessment.json'
import autoSearchZhTW from './zh_TW/autoSearch.json'
import commonZhTW from './zh_TW/common.json'
import commonDistanceZhTW from './zh_TW/commonDistance.json'
import crTargetZhTW from './zh_TW/crTarget.json'
import custCarbonAuditZhTW from './zh_TW/custCarbonAudit.json'
import detailsMgmtZhTW from './zh_TW/detailsMgmt.json'
import deviceZhTW from './zh_TW/device.json'
import documentShareZhTW from './zh_TW/documentShare.json'
import esgAnnualInfoZhTW from './zh_TW/esgAnnualInfo.json'
import formItemsZhTW from './zh_TW/formItems.json'
import globalEmSourceZhTW from './zh_TW/globalEmSource.json'
import goodsZhTW from './zh_TW/goods.json'
import importSettingZhTW from './zh_TW/importSetting.json'
import languagesZhTW from './zh_TW/languages.json'
import menuZhTW from './zh_TW/menu.json'
import modifyDetailsModalZhTW from './zh_TW/modifyDetailsModal.json'
import powerSavingZhTW from './zh_TW/powerSaving.json'
import powerinputZhTW from './zh_TW/powerinput.json'
import regionCoeffiZhTW from './zh_TW/regionCoeffi.json'
import rentalAssetsZhTW from './zh_TW/rentalAssets.json'
import reportApprovalZhTW from './zh_TW/report-approval.json'
import globalCarbonReductionZhTW from './zh_TW/report-globalCarbonReduction.json'
import globalEmZhTW from './zh_TW/report-globalEm.json'
import reportZhTW from './zh_TW/report.json'
import richEditorZhTW from './zh_TW/richEditor.json'
import shipmentZhTW from './zh_TW/shipment.json'
import ssoLoginZhTW from './zh_TW/ssoLogin.json'
import systemZhTW from './zh_TW/system.json'
import tableColumnsZhTW from './zh_TW/tableColumns.json'

// 動態載入語系檔案的 helper function
const loadLanguageResources = async (lang: string) => {
  const jsonFiles = [
    `./${lang}/account.json`,
    `./${lang}/alert.json`,
    `./${lang}/common.json`,
    `./${lang}/commonDistance.json`,
    `./${lang}/crTarget.json`,
    `./${lang}/detailsMgmt.json`,
    `./${lang}/device.json`,
    `./${lang}/formItems.json`,
    `./${lang}/globalEmSource.json`,
    `./${lang}/goods.json`,
    `./${lang}/importSetting.json`,
    `./${lang}/languages.json`,
    `./${lang}/menu.json`,
    `./${lang}/modifyDetailsModal.json`,
    `./${lang}/powerinput.json`,
    `./${lang}/regionCoeffi.json`,
    `./${lang}/report-approval.json`,
    `./${lang}/report-globalCarbonReduction.json`,
    `./${lang}/report-globalEm.json`,
    `./${lang}/report.json`,
    `./${lang}/system.json`,
    `./${lang}/tableColumns.json`,
    `./${lang}/custCarbonAudit.json`,
    `./${lang}/powerSaving.json`,
    `./${lang}/esgAnnualInfo.json`,
    `./${lang}/documentShare.json`,
    `./${lang}/autoSearch.json`,
    `./${lang}/ssoLogin.json`,
    `./${lang}/rentalAssets.json`,
    `./${lang}/richEditor.json`,
    `./${lang}/assessment.json`,
    `./${lang}/shipment.json`,
  ]

  try {
    const results: any[] = await Promise.allSettled(
      jsonFiles.map(file => import(`${file}`, { assert: { type: 'json' } }))
    )

    const resources: any = {}
    const namespaceMap = [
      'account',
      'alert',
      'common',
      'commonDistance',
      'crTarget',
      'detailsMgmt',
      'device',
      'formItems',
      'globalEmSource',
      'goods',
      'importSetting',
      'languages',
      'menu',
      'modifyDetailsModal',
      'powerinput',
      'regionCoeffi',
      'reportApproval',
      'globalCarbonReduction',
      'globalEm',
      'report',
      'system',
      'tableColumns',
      'custCarbonAudit',
      'powerSaving',
      'esgAnnualInfo',
      'documentShare',
      'autoSearch',
      'ssoLogin',
      'rentalAssets',
      'richEditor',
      'assessment',
      'shipment',
    ]

    results.forEach((result, index) => {
      const namespace = namespaceMap[index]
      if (result.status === 'fulfilled' && result.value?.default) {
        resources[namespace] = result.value.default
      }
    })

    return resources
  } catch (err) {
    console.error(`載入語系 ${lang} 失敗:`, err)
    return {}
  }
}

// 決定預設語系
const getDefaultLang = () => {
  const navLang = navigator.language.replace('-', '_')
  const supportedLangs = ['zh_TW', 'en_US', 'zh_CN', 'th_TH', 'vi_VN', 'ja_JP']
  return supportedLangs.includes(navLang) ? navLang : 'zh_TW'
}

const defaultLang = getDefaultLang()

// 僅同步載入 zh_TW 和 dev 作為初始資源
const initialResources: any = {
  zh_TW: {
    alert: alertZhTW,
    account: accountZhTW,
    common: commonZhTW,
    device: deviceZhTW,
    formItems: formItemsZhTW,
    goods: goodsZhTW,
    menu: menuZhTW,
    report: reportZhTW,
    system: systemZhTW,
    tableColumns: tableColumnsZhTW,
    importSetting: importSettingZhTW,
    regionCoeffi: regionCoeffiZhTW,
    commonDistance: commonDistanceZhTW,
    powerinput: powerinputZhTW,
    globalEm: globalEmZhTW,
    crTarget: crTargetZhTW,
    globalCarbonReduction: globalCarbonReductionZhTW,
    globalEmSource: globalEmSourceZhTW,
    detailsMgmt: detailsMgmtZhTW,
    modifyDetailsModal: modifyDetailsModalZhTW,
    reportApproval: reportApprovalZhTW,
    languages: languagesZhTW,
    custCarbonAudit: custCarbonAuditZhTW,
    powerSaving: powerSavingZhTW,
    esgAnnualInfo: esgAnnualInfoZhTW,
    documentShare: documentShareZhTW,
    autoSearch: autoSearchZhTW,
    ssoLogin: ssoLoginZhTW,
    rentalAssets: rentalAssetsZhTW,
    richEditor: richEditorZhTW,
    assessment: assessmentZhTW,
    shipment: shipmentZhTW,
  },
  dev: {
    alert: alertDev,
    account: accountDev,
    common: commonDev,
    device: deviceDev,
    formItems: formItemsDev,
    goods: goodsDev,
    menu: menuDev,
    report: reportDev,
    system: systemDev,
    tableColumns: tableColumnsDev,
    importSetting: importSettingDev,
    regionCoeffi: regionCoeffiDev,
    commonDistance: commonDistanceDev,
    powerinput: powerinputDev,
    globalEm: globalEmDev,
    crTarget: crTargetDev,
    globalCarbonReduction: globalCarbonReductionDev,
    globalEmSource: globalEmSourceDev,
  },
}

// 初始化 i18n（僅使用 zh_TW 和 dev 作為初始資源）
i18n.use(initReactI18next).init({
  ns: [
    'alert',
    'account',
    'common',
    'device',
    'formItems',
    'goods',
    'menu',
    'report',
    'system',
    'tableColumns',
    'importSetting',
    'regionCoeffi',
    'commonDistance',
    'globalEm',
    'crTarget',
    'globalCarbonReduction',
    'globalEmSource',
    'detailsMgmt',
    'modifyDetailsModal',
    'reportApproval',
    'languages',
    'powerinput',
    'powerSaving',
    'esgAnnualInfo',
    'documentShare',
    'autoSearch',
    'ssoLogin',
    'rentalAssets',
    'richEditor',
    'assessment',
    'shipment',
  ],
  defaultNS: 'common',
  resources: initialResources,
  lng: defaultLang,
  fallbackLng: 'zh_TW',
  keySeparator: false,
  react: {
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'sub'],
  },
})

// 如果預設語系不是 zh_TW，在初始化後立即載入預設語系
if (defaultLang !== 'zh_TW' && defaultLang !== 'dev') {
  loadLanguageResources(defaultLang).then(resources => {
    Object.keys(resources).forEach(namespace => {
      if (resources[namespace]) {
        i18n.addResourceBundle(defaultLang, namespace, resources[namespace])
      }
    })
    // 切換到預設語系
    i18n.changeLanguage(defaultLang)
  })
}

// 處理語系切換時的 lazy loading
i18n.on('languageChanged', async (lang: string) => {
  const currentLang = i18n.services.resourceStore.data[lang]
  if (currentLang) {
    // 語系已載入，跳過
    return
  }

  // 如果是 zh_TW 或 dev，已經同步載入，跳過
  if (lang === 'zh_TW' || lang === 'dev') {
    return
  }

  // 動態載入語系資源
  const resources = await loadLanguageResources(lang)

  // 將資源加入 i18n
  Object.keys(resources).forEach(namespace => {
    if (resources[namespace]) {
      i18n.addResourceBundle(lang, namespace, resources[namespace])
    }
  })
})

export default i18n
